import { Button, Checkbox } from "@mui/material"

export function AcceptAllButton({ changes, onAcceptAll }) {
    const acceptedCount = changes.filter((c) => c.decision === "accept").length
    const allAccepted = changes.length > 0 && acceptedCount === changes.length
    const someAccepted = acceptedCount > 0 && !allAccepted

    const buttonVariant = allAccepted ? "contained" : "outlined"
    const buttonColor = allAccepted || someAccepted ? "success" : "inherit"
    const checkboxColor = allAccepted ? "common.white" : "success.main"

    return (
        <Button
            size="small"
            variant={buttonVariant}
            color={buttonColor}
            onClick={handleClick}
            startIcon={
                <Checkbox
                    checked={allAccepted}
                    indeterminate={someAccepted}
                    size="small"
                    sx={{
                        p: 0,
                        pointerEvents: "none",
                        color: checkboxColor,
                        "&.Mui-checked": { color: "common.white" },
                    }}
                />
            }
            sx={allAccepted ? { color: "common.white" } : undefined}
        >
            Accept All
        </Button>
    )

    function handleClick() {
        if (allAccepted) {
            onAcceptAll(null)
        } else {
            onAcceptAll("accept")
        }
    }
}
